import { Component } from '@angular/core';
import { DividendComponent } from './dividend.component';

@Component({
  selector: 'eid-dividend-desktop',
  templateUrl: './dividend.desktop.component.html',
  styleUrls: ['./dividend.desktop.component.scss']
})
export class DividendDesktopComponent extends DividendComponent {}
